import React from "react";
import ReactDOM from "react-dom/client";

import { config } from "@app/config";

import { CollectionGrid, type Props } from "./component";

const App = class extends HTMLElement {
  root: ReactDOM.Root | null = null;

  connectedCallback() {
    let props: Partial<Props> = {
      config,
    };

    this.querySelectorAll("script").forEach((script) => {
      try {
        const data = JSON.parse(script.innerHTML);
        const name = script.getAttribute("name");

        if (!name) return;

        props[name as keyof Props] = data;
      } catch (error) {
        console.error(error);
      }
    });

    if (!this.root) this.root = ReactDOM.createRoot(this);
    this.root.render(<CollectionGrid {...(props as Props)} />);
  }
};

customElements.define("x-collection-grid", App);
